import { Injectable } from '@angular/core';
import { ToastComponent } from '../components/toast/toast.component';
import { ActiveToast, ToastrIconClasses, ToastrService } from 'ngx-toastr';

interface toastOptions {
  message: string;
  type?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(private toastr: ToastrService) {}
  showToast(options: toastOptions): ActiveToast<toastOptions> {
    const iconClasses: ToastrIconClasses = {
      error: 'bi bi-x-octagon',
      success: 'bi bi-check-circle',
      info: 'bi bi-info-circle',
      warning: 'bi bi-exclamation-diamond'
    };

    const configOptions = {
      timeOut: 5000,
      closeButton: true,
      tapToDismiss: false,
      toastComponent: ToastComponent
    };

    this.toastr.toastrConfig.iconClasses = iconClasses;
    this.toastr.toastrConfig.toastClass = `override-icon toast-${options.type}`;
    this.toastr.toastrConfig.disableTimeOut = 'extendedTimeOut';
    this.toastr.toastrConfig.easing = 'ease-in-out';
    this.toastr.toastrConfig.easeTime = '150';
    this.toastr.toastrConfig.enableHtml = false;
    this.toastr.toastrConfig.positionClass = 'top-center';

    switch (options.type) {
      case 'success':
        return this.toastr.success(options.message, 'Success.. !', configOptions);
      case 'warning':
        return this.toastr.warning(options.message, 'Warning !', configOptions);
      case 'error':
        return this.toastr.error(options.message, 'Oops.. !', configOptions);
      default:
        return this.toastr.info(options.message, 'Note !', configOptions);
    }
  }
}
